document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-inbus-parentchild-url]');
  if (!btn) return;
  if (btn.disabled) return;

  const url = btn.getAttribute('data-inbus-parentchild-url');
  if (url) window.location.assign(url);
});

const inbusPrefetchDoc = (url) => {
  if (!url) return;
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = url;
  link.as = 'document';
  document.head.appendChild(link);
};

document.addEventListener(
  'pointerenter',
  (e) => {
    const btn = e.target.closest('[data-inbus-parentchild-url]');
    if (!btn || btn.disabled) return;
    inbusPrefetchDoc(btn.getAttribute('data-inbus-parentchild-url'));
  },
  true
);

document.addEventListener(
  'touchstart',
  (e) => {
    const btn = e.target.closest('[data-inbus-parentchild-url]');
    if (!btn || btn.disabled) return;
    inbusPrefetchDoc(btn.getAttribute('data-inbus-parentchild-url'));
  },
  { passive: true }
);

document.addEventListener('change', (e) => {
  const sel = e.target.closest('[data-inbus-parentchild-select]');
  if (!sel) return;
  const url = sel.value;
  if (url) window.location.assign(url);
});

